import { Box, makeStyles, Switch } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AboutDarkModeTooltip from 'src/components/AboutDarkModeTooltip';
import { RootState } from 'src/store';
import { editSwitchDarkMode } from 'src/store/modules/switchButton';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F5F5F5'
  }
}));
export default function SwitchDarkMode() {
  const switchDarkMode = useSelector(
    (state: RootState) => state.switchButton.switchDarkMode
  );
  const dispatch = useDispatch();
  const classes = useStyles();
  const [checked, setChecked] = useState(switchDarkMode);

  const handleChange = () => {
    setChecked(prev => !prev);
    dispatch(editSwitchDarkMode(!checked));
  };

  return (
    <div>
      <Box className={classes.wrapper}>
        <span
          style={{
            fontSize: '0.875rem',
            fontWeight: 600,
            fontFamily: 'Archivo',
            letterSpacing: '0.0175rem'
          }}
        >
          SUPPORT DARK MODE
        </span>
        <AboutDarkModeTooltip />
        <Switch checked={checked} onChange={handleChange} color="primary" />
      </Box>
    </div>
  );
}
